var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import * as React from 'react';
import { string, number } from 'prop-types';
import { declMod } from '@yandex-lego/i-bem-react';

import _iServices from "./../../../i-services/i-services.react.js";

var IServices = _iServices.applyDecls();

import _user2__menuCounter from "./../../__menu-counter/user2__menu-counter.react.js";

var MenuCounter = _user2__menuCounter.applyDecls();

import "./../../__menu-counter/user2__menu-counter.css";


export default declMod({ action: 'mail' }, {
    block: 'user2',
    elem: 'menu-item',
    content: function content() {
        var _props = this.props,
            contentRegion = _props.contentRegion,
            unreadCount = _props.unreadCount;

        return [IServices.serviceName('mail', contentRegion), React.createElement(MenuCounter, { key: 'menu-counter', count: unreadCount })];
    },
    attrs: function attrs(_ref) {
        var contentRegion = _ref.contentRegion;

        return _extends({}, this.__base.apply(this, arguments), {
            href: IServices.serviceUrl('mail', contentRegion)
        });
    }
}, {
    propTypes: {
        contentRegion: string.isRequired,
        unreadCount: number.isRequired
    }
});